export default __webpack_public_path__ + "static/media/cloudDeploy.f35c5983.svg";